export default __webpack_public_path__ + "static/media/2026-03-27 12.29.44.597adfe5.jpg";